import { render, staticRenderFns } from "./addDocument.vue?vue&type=template&id=a6060df8&scoped=true"
import script from "./addDocument.vue?vue&type=script&lang=js"
export * from "./addDocument.vue?vue&type=script&lang=js"
import style0 from "./addDocument.vue?vue&type=style&index=0&id=a6060df8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6060df8",
  null
  
)

export default component.exports